import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError, fileUrl } from "@/lib/api";
import { Upload, X, Image as ImageIcon, Video, FileText } from "lucide-react";

export function MediaManager({ value = [], onChange, makePublic = false, label = "Add media", accept = "image/*,video/*,.pdf,.doc,.docx,.xls,.xlsx,.csv,.txt", testid = "media-manager" }) {
  const [busy, setBusy] = useState(false);
  const up = async (e) => {
    const files = Array.from(e.target.files || []);
    e.target.value = "";
    if (!files.length) return;
    setBusy(true);
    try {
      const added = [];
      for (const file of files) {
        const fd = new FormData();
        fd.append("file", file);
        const { data } = await api.post(`/media/upload?make_public=${makePublic}`, fd);
        added.push(data);
      }
      onChange([...(value || []), ...added]);
      toast.success(`${added.length} file(s) added`);
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  const remove = (id) => onChange((value || []).filter((m) => m.id !== id));
  const iconFor = (k) => (k === "image" ? ImageIcon : k === "video" ? Video : FileText);
  return (
    <div data-testid={testid}>
      <label className="inline-flex">
        <input type="file" multiple accept={accept} className="hidden" data-testid={`${testid}-input`} onChange={up} disabled={busy} />
        <span className={`inline-flex items-center gap-2 font-head font-bold uppercase tracking-wider text-xs px-3 py-2 border-2 border-zinc-700 bg-zinc-900 text-white cursor-pointer hover:border-[#FF5722] ${busy ? "opacity-50 pointer-events-none" : ""}`}><Upload size={14} /> {busy ? "Uploading…" : label}</span>
      </label>
      {(value || []).length > 0 && (
        <div className="mt-3 grid grid-cols-2 sm:grid-cols-3 gap-2">
          {value.map((m) => {
            const I = iconFor(m.kind);
            return (
              <div key={m.id} className="relative border-2 border-zinc-800 bg-black/40 p-2" data-testid={`${testid}-item-${m.id}`}>
                <button type="button" onClick={() => remove(m.id)} data-testid={`${testid}-remove-${m.id}`} className="absolute -top-2 -right-2 bg-red-600 text-white w-5 h-5 flex items-center justify-center border border-black z-10"><X size={12} /></button>
                {m.kind === "image"
                  ? <img src={fileUrl(m.id)} alt={m.name} className="w-full h-20 object-cover" />
                  : <div className="w-full h-20 flex flex-col items-center justify-center text-zinc-400"><I size={22} /><span className="font-mono text-[9px] mt-1 truncate max-w-full px-1">{m.name}</span></div>}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
